import { Component, Prop, Vue } from 'vue-property-decorator';
import { mediaServerUrl800 } from '@/helpers/data';
import ImageWithFallback from '../image-with-fallback/image-with-fallback.vue';

@Component({
  components: {
    ImageWithFallback,
  },
})
export default class ShowImageDialog extends Vue {

  @Prop()
  readonly src!: string;

  @Prop()
  readonly fallbackTitle!: string;

  // TODO: Adapt to use logic like in base dialog
  readonly dialogMaxWidth = 800;

  dialogVisible = false;

  mediaServerUrl800 = mediaServerUrl800;

  closeDialog(): void {
    this.dialogVisible = false;
  }

}
